export default __webpack_public_path__ + "static/media/screen7.4ef207f2.png";